import { isNsContent } from "lib-core"
import { Post } from "posts/posts.types"
import { summaryCondition, blockContent } from "./postSummary"
import { AssetFields } from "../../lib-core/src/assets/EditAssetPage"



export const getPostSummary = (post: Post) => {
    return post.content.find(summaryCondition) || { content: post.content.slice(0, 3) }
}


const stripHtml = (str: string) => str.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/\s+/g, ' ').trim()

export const getPostSummaryText = (post: Post) => {
    if (post.type === "asset") {
        const data: AssetFields = post && post.form && post.form.data && post.form.data
        if (data.shortDescription) {
            return stripHtml(data.shortDescription)
        }
    }

    if (!post.content) {
        return ""
    }
    if (isNsContent(post.content)) {
        const html = post.content.nsHtml || ""
        const summary = stripHtml(html.slice(0, 1000))
        const title = post.title.replace(/\s+/g, ' ').trim()
        const summary1 = summary.replace(title, "")
        return summary1.replace(/^[\s.,!?]+|[\s.,]+$/g, '').slice(0, 255)
    }
    try {
        return blockContent(getPostSummary(post)).join(" ").trim()
    } catch (e) {
        console.error(e)
    }
}
